module.exports = __webpack_public_path__ + "img/2.6cf5f7bf.jpg";